// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__LLBip","content":"Layout_content__EPcrl"};